module.exports = __webpack_public_path__ + "img/battery_0green.f450fcfe.png";